import { useMutation } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useUpdateCustomSurveyMutation = ({
	impersonationContext,
	onError,
	onSuccess,
}: {
	impersonationContext?: Api.IImpersonationContext;
	onError?: (error: Api.IOperationResultNoValue) => void;
	// react-query passes (data, variables, context) — variables exposes the PUT payload
	// so callers can re-sync local form state from exactly what was saved.
	onSuccess?: (data?: Api.ICustomSurvey, variables?: { survey: Api.ICustomSurvey }) => void;
}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ survey }: { survey: Api.ICustomSurvey }) => {
			return userSession.webServiceHelper.callAsync<Api.ICustomSurvey>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `survey/custom/${survey.id}`,
				}),
				'PUT',
				survey
			);
		},
		onError,
		onSuccess,
	});
};
